import { render, staticRenderFns } from "./header-footer-element.vue?vue&type=template&id=4cf2f10e"
import script from "./header-footer-element.vue?vue&type=script&lang=js"
export * from "./header-footer-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports